import { Link } from 'react-router-dom';
import type { Topic } from '@/types/content';

interface TopicCardProps {
  topic: Topic;
  categoryName: string;
  variant?: 'default' | 'compact';
}

export default function TopicCard({ topic, categoryName, variant = 'default' }: TopicCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/topic/${topic.id}`}
        className="group flex gap-4 p-3 rounded-lg border border-background-200 hover:border-primary-300 transition-colors bg-background-50"
      >
        <div className="w-28 h-20 shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={topic.cover}
            alt={`${topic.title} - 看料社专题封面`}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="flex flex-col justify-center min-w-0">
          <span className="text-xs text-primary-600 mb-1">{categoryName}</span>
          <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {topic.title}
          </h3>
          <span className="mt-1.5 text-xs text-foreground-500">
            {topic.articleCount} 篇整理 · 更新于 {topic.updateTime}
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/topic/${topic.id}`}
      className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full h-48 overflow-hidden bg-background-200">
        <img
          src={topic.cover}
          alt={`${topic.title} - 看料社专题封面`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs bg-background-50/95 text-foreground-900">
          {categoryName}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-5">
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {topic.title}
        </h3>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
          {topic.summary}
        </p>
        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-file-list-3-line" />
            {topic.articleCount} 篇整理
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-fire-line text-primary-500" />
            热度 {topic.hotScore}
          </span>
        </div>
      </div>
    </Link>
  );
}